// Simple Error component that uses the same pattern as LoadingScreen
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoadingScreen.css'; // Reuse the same styles
import Footer from '../_Components/Footer';

function ErrorScreen({ 
  title = "Errore",
  message = "Si è verificato un errore imprevisto.",
  showRetry = true,
  showGoBack = true,
  onRetry = null,
  showFooter = true,
  retryText = "Riprova",
  goBackText = "Torna al menu"
}) {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  const handleGoBack = () => {
    navigate('/start');
  };

  return (
    <div className="loading-screen"> {/* Reuse loading screen styles */}
      <div id='container'>
        <div className="main-content loading-content">
        <div className="error-icon" style={{ fontSize: '64px', marginBottom: '20px' }}>
          ⚠️
        </div>
        <h2 className="loading-text" style={{ color: '#dc3545' }}>
          {title}
        </h2>
        <p style={{ 
          color: '#666', 
          textAlign: 'center', 
          margin: '20px 0',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          flexDirection: window.innerWidth < 768 ? 'column' : 'row',
          alignItems: 'center'
        }}>
          {showRetry && (
            <button 
              onClick={handleRetry}
            >
              {retryText}
            </button>
          )}
          
          {showGoBack && (
            <button 
              onClick={handleGoBack}
            >
              {goBackText}
            </button>
          )}
        </div>
        </div>
        {showFooter && <Footer />}
      </div>
    </div>
  );
}

export default ErrorScreen;